import React from 'react';
import loadable from '@loadable/component';

const Loader = loadable(() => import('components/Loader'));

export function buttonTitle(isSending, title, customLoaderStyling) {

  if (isSending) return (
    <Loader
      thisStyles={customLoaderStyling ? customLoaderStyling : { height: '4.5rem'}}
      notFullHeight={true}
    />
  );

  return title ? title : 'Ok';
}
